module.exports = __webpack_public_path__ + "static/img/ecg_process.1fb7088.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecg_process.gif
// module id = 890A
// module chunks = 7